<template>
  <div v-loading="isLoading">
    <!-- not jettainer -->
    <print-template
      :viewExtraFooter="false"
      :viewFooter="false"
      :viewHeader="true"
      :viewSubheader="false"
      v-if="!table.info.is_jettainer"
    >
      <div class="form-wrapper">
        <div class="form-head">
          <h3 class="text-center mt-5 mb-5">DELIVERY NOTE</h3>
          <el-button
            class="mb-2 mt-2 h-print"
            size="small"
            type="primary"
            @click="$refs.dialog.open()"
            >Edit Delivery Note Details</el-button
          >
          <app-dialog ref="dialog" cancelText="Close">
            <el-form>
              <el-form-item label="Company">
                <el-input v-model="reportData.company"></el-input>
              </el-form-item>
              <el-form-item label="Address">
                <el-input v-model="reportData.address"></el-input>
              </el-form-item>
              <el-form-item label="Attention">
                <el-input v-model="reportData.attention"></el-input>
              </el-form-item>
              <el-form-item label="Remarks">
                <el-input
                  type="textarea"
                  v-model="reportData.remarks"
                ></el-input>
              </el-form-item>
            </el-form>
          </app-dialog>
          <table class="mb-3">
            <colgroup>
              <col
                v-for="i in 30"
                :key="`col-${i}`"
                style="width: calc(100% / 3)"
              />
            </colgroup>
            <tr>
              <td
                style="border-top: 1px solid #333; border-left: 1px solid #333; border-right: 1px solid #333"
                colspan="2"
              >
                Company: {{ reportData.company }}
              </td>
              <td>D.N. No.: {{ table.info.batch_no }}</td>
            </tr>
            <tr>
              <td
                style="border-left: 1px solid #333; border-right: 1px solid #333"
                colspan="2"
              >
                Address: {{ reportData.address }}
              </td>
              <td>Date: {{ table.info.delivery_date | dateFormat }}</td>
            </tr>
            <tr>
              <td
                style="border-bottom: 1px solid #333; border-left: 1px solid #333; border-right: 1px solid #333"
                colspan="2"
              >
                Attention: {{ reportData.attention }}
              </td>
              <td></td>
            </tr>
          </table>

          <table class="table table-bordered mb-2">
            <colgroup>
              <col
                v-for="i in 30"
                :key="`col-${i}`"
                style="width: calc(100% / 3)"
              />
            </colgroup>
            <thead>
              <tr>
                <th>Item No.</th>
                <th>TSO Serial No</th>
                <th>ULD ID CODE</th>
              </tr>
            </thead>
            <!-- v-for="i in 100" :key="i" -->
            <tbody>
              <tr v-for="(item, index) in table.data" :key="item.id">
                <td class="text-center">{{ index + 1 }}</td>
                <td>{{ item.tso_ser_no }}</td>
                <td class="text-center">{{ item.uld_id_code }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="text-left">
        <label>Remarks:</label>
        <p style="min-height: 100px; margin-top: 0">
          {{ reportData.remarks }}
        </p>
        <p>
          I hereby acknowledge that I received the above-mentioned items in good
          condition.
        </p>
        <ul class="list-unstyled w-50">
          <li style="position: relative; margin-bottom: 15px">
            Received by:
            <label
              style="border-bottom: 1px solid #333; display: block; width: 250px; position: absolute; left: 100px; bottom: 3px "
            ></label>
          </li>
          <li style="position: relative">
            Date &amp; Time:
            <label
              style="border-bottom: 1px solid #333; display: block; width: 250px; position: absolute; left: 100px; bottom: 3px "
            ></label>
          </li>
        </ul>
      </div>
      <!-- <template v-slot:customFooter>
        <div class="text-left">
          <p>
            I hereby acknowledge that I received the above-mentioned items in
            good condition.
          </p>
          <ul class="list-unstyled">
            <li>Received by:</li>
            <li>Date &amp; Time:</li>
          </ul>
        </div>
      </template> -->
    </print-template>
    <!-- jettainer -->
    <print-template
      :viewExtraFooter="false"
      :viewFooter="false"
      :viewHeader="false"
      v-if="table.info.is_jettainer"
      class="jettainer-print"
    >
      <div class="form-wrapper-jettainer">
        <div class="form-head">
          <table class="table table-bordered">
            <tr>
              <td style="border-right: 0; text-align: center">
                <img src="/images/jettainer-logo.png" alt="jettainer-logo" />
              </td>
              <td style="border-left: 0; text-align: center">
                <h1 class="mb-0">DELIVERY NOTE</h1>
              </td>
              <td>
                DATE:
                <b>{{ info.delivery_date | dateFormat("DD-MMM YYYY") }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border-bottom: 0">
                2. Organization issuing this form:
              </td>
              <td>DELIVERY NOTE NUMBER</td>
            </tr>
            <tr>
              <td class="text-center" colspan="2" style="border-top: 0">
                <b>TOTAL EXPERTISE, LTD. - ABU DHABI, U.A.E</b>
              </td>
              <td class="text-center">
                <b>{{ info.batch_no }}</b>
              </td>
            </tr>
          </table>

          <table class="table table-bordered mt-2 mb-2">
            <thead>
              <tr>
                <th>4. Item</th>
                <th>5. Description</th>
                <th>6. Part No.</th>
                <th colspan="2">7. ULD ID Code - Serial</th>
                <th>8. Status</th>
              </tr>
            </thead>
            <!-- v-for="i in 100" :key="i" -->
            <tbody>
              <tr v-for="(item, index) in table.data" :key="item.id">
                <td class="text-center">{{ index + 1 }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.part_no }}</td>
                <td>{{ item.uld_id_code }}</td>
                <td>{{ item.tso_ser_no }}</td>
                <td>{{ item.status }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="text-left" style="border: 2px solid #333; padding: 8px 12px">
        <table class="table">
          <tr>
            <td colspan="3">
              <p class="mb-2 mt-0">Received by:</p>
            </td>
          </tr>
          <tr>
            <td style="width:45%">Signature: _________________________</td>
            <td style="width:23%">Date: ___________</td>
            <td>
              <img src="/images/jettainer-logo.png" alt="jettainer-logo" />
            </td>
          </tr>
          <tr>
            <td colspan="2">Printed Name: _____________________</td>
            <td>
              <b style="font-size: 14px">Copies to be sent to Jettainer</b>
            </td>
          </tr>
        </table>
      </div>
      <!-- <template v-slot:customFooter>
        <div class="text-left">
          <p>
            I hereby acknowledge that I received the above-mentioned items in
            good condition.
          </p>
          <ul class="list-unstyled">
            <li>Received by:</li>
            <li>Date &amp; Time:</li>
          </ul>
        </div>
      </template> -->
    </print-template>
  </div>
</template>

<script>
import PrintTemplate from "@/components/PrintTemplate.vue";
import ULD from "@/models/ULD";
export default {
  name: "ULDBatchInfo",
  components: { PrintTemplate },
  data: () => ({
    isLoading: false,
    table: { info: {} },
    reportData: {}
  }),
  computed: {
    info() {
      if (this.table.data && this.table.data.length) {
        let item = this.table.data[0];
        return item;
      }
      return {};
    }
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      // fetch
      ULD.get_uld_out({ batch_id: this.$route.params.id, limit: 9999 }).then(
        resp => {
          this.table = resp;
          this.isLoading = false;
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.form-wrapper-jettainer .form-head {
  min-height: 900px;
}
.form-head {
  min-height: 650px;
}
@media print {
  .form-head {
    min-height: 650px;
    h3 {
      margin-top: 0;
    }
  }
  .form-wrapper-jettainer .form-head {
    min-height: 860px;
  }
}

::v-deep {
  @media print {
    .jettainer-print {
      .footer-space {
        height: 0 !important;
      }
      .header-space {
        height: 50px !important;
      }
    }
    // .footer-space {
    //   height: 80px !important;
    // }
  }
}
</style>
